<template>
  <v-container py-0>
    <v-card color="transparent" flat light>
      <v-card-text class="py-0">
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.active') }}
          </v-flex>
          <v-flex xs12 md6>
            <button-state :state="entity.active" />
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.entities.client') }}
          </v-flex>
          <v-flex xs12 md6>
            <button-state :state="entity.isCustomer" />
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.name') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ entity.name || '--' }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.logo') }}
          </v-flex>
          <v-flex xs12 md6>
            <v-avatar v-if="imageUrl" size="32">
              <img :src="imageUrl" alt />
            </v-avatar>
            <span v-else>--</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.entities.siteUrl') }}
          </v-flex>
          <v-flex xs12 md6>
            <a v-if="entity.web" :href="entity.web">{{ entity.web }}</a>
            <span v-else>--</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.users.phone') }}
          </v-flex>
          <v-flex xs12 md6>
            <template v-if="entity.telf && entity.telf.length">
              <v-chip
                v-for="(item, index) of entity.telf"
                :key="item + index"
                color="primary"
                dark
                small
              >
                {{ item }}
              </v-chip>
            </template>
            <span v-else>--</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.users.email') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ entity.email || '--' }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.users.address') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ entity.address || '--' }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.users.cp') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ entity.cp || '--' }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('titles.entities.fedCode') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ entity.fedCode || '--' }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $tc('models.stadium', 2) }}
          </v-flex>
          <v-flex xs12 md6>
            <template v-if="entity.stadiumId && entity.stadiumId.length">
              <v-chip
                v-for="(stadium, index) of entity.stadiumId"
                :key="index + 533"
                color="transparent"
                small
              >
                <v-avatar v-if="stadium.photo">
                  <v-img :src="stadium.photo" />
                </v-avatar>
                {{ stadium.name }}
              </v-chip>
            </template>
            <span v-else>--</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $tc('models.country') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ entity.countryId ? entity.countryId.name : '--' }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $tc('models.province') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ entity.provinceId ? entity.provinceId.name : '--' }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $tc('models.town') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ entity.townId ? entity.townId.name : '--' }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            <v-icon color="blue"> fa fa-facebook-square </v-icon>
            {{ $t('titles.entities.facebook') }}
          </v-flex>
          <v-flex xs12 md6>
            <a v-if="entity.facebook" :href="entity.facebook">{{
              entity.facebook
            }}</a>
            <span v-else>--</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            <v-icon color="light-blue"> fa fa-twitter-square </v-icon>
            {{ $t('titles.entities.twitter') }}
          </v-flex>
          <v-flex xs12 md6>
            <a v-if="entity.twitter" :href="entity.twitter">{{
              entity.twitter
            }}</a>
            <span v-else>--</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            <v-icon color="purple"> fa fa-instagram </v-icon>
            {{ $t('titles.entities.instagram') }}
          </v-flex>
          <v-flex xs12 md6>
            <a v-if="entity.instagram" :href="entity.instagram">{{
              entity.instagram
            }}</a>
            <span v-else>--</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.createdBy') }}
          </v-flex>
          <v-flex xs12 md6>
            {{
              entity.createdBy
                ? entity.createdBy.name + ' ' + entity.createdBy.lastname1
                : '--'
            }}
          </v-flex>
        </v-layout>
        <v-layout row wrap my-3>
          <v-flex xs12 md4 class="body-2">
            {{ $t('fields.global.createdAt') }}
          </v-flex>
          <v-flex xs12 md6>
            {{ formatDate(entity.createdAt) }}
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { formatDate } from '@/helpers/dateHelper'
export default {
  name: 'TabView',
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
  },
  computed: {
    ...mapState({
      entity: (state) => state.entities.selected,
    }),
    imageUrl() {
      if (this.entity.logo && this.entity.logo.includes('http')) {
        return this.entity.logo
      } else return this.defaultValues.imageUrl + this.entity.logo
    },
  },
  methods: {
    ...mapActions({
      reset: 'entities/reset',
      resetTeamState: 'teams/resetState',
    }),
    formatDate(date) {
      return formatDate(date, true)
    },
    cancel() {
      this.tab = 0
      this.reset()
      this.resetTeamState()
      this.$emit('close')
    },
  },
}
</script>
